<script>
  export let text = '';
  export let date = '';
  export let link = '';
</script>

<style type="text/scss">
  @import './styles/theme.scss';

  .info {
    position: relative;
    color: $c-gray-0;
    font-family: $ff-sans;
    @include fluid-font-size($fs-base);
    @include fluid-space(padding, $sp-base);
    @include fluid-space(margin-bottom, $sp-medium);
    border: 1px solid $c-gray-4;
    text-align: center;
    margin: 0 auto;
    max-width: 80%;

    @media #{$m-min-md} {
      width: 50%;
    }
  }
  .info__date {
    @include fluid-font-size($fs-small);
    font-weight: normal;
    color: #999;
    margin-bottom: 5px;
  }
  .info__text {
    @include fluid-font-size($fs-base);
    line-height: $lh-base;
  }
  .info__text a {
    font-weight: normal;
    color: $c-gray-2;
  }
</style>

<div class="info">
  <div class="info__date">{date}</div>
  <div class="info__text">
    {text}
    <a href={link} target="_blank">(Quelle)</a>
  </div>
</div>
